/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LootboxRedemptionTransactionHistoryItem } from './LootboxRedemptionTransactionHistoryItem';
import {
    LootboxRedemptionTransactionHistoryItemFromJSON,
    LootboxRedemptionTransactionHistoryItemFromJSONTyped,
    LootboxRedemptionTransactionHistoryItemToJSON,
    LootboxRedemptionTransactionHistoryItemToJSONTyped,
} from './LootboxRedemptionTransactionHistoryItem';
import type { LootboxRedemptionTransactionHistoryResponsePagination } from './LootboxRedemptionTransactionHistoryResponsePagination';
import {
    LootboxRedemptionTransactionHistoryResponsePaginationFromJSON,
    LootboxRedemptionTransactionHistoryResponsePaginationFromJSONTyped,
    LootboxRedemptionTransactionHistoryResponsePaginationToJSON,
    LootboxRedemptionTransactionHistoryResponsePaginationToJSONTyped,
} from './LootboxRedemptionTransactionHistoryResponsePagination';

/**
 * 
 * @export
 * @interface LootboxRedemptionTransactionHistoryResponse
 */
export interface LootboxRedemptionTransactionHistoryResponse {
    /**
     * 
     * @type {Array<LootboxRedemptionTransactionHistoryItem>}
     * @memberof LootboxRedemptionTransactionHistoryResponse
     */
    transactions?: Array<LootboxRedemptionTransactionHistoryItem>;
    /**
     * 
     * @type {LootboxRedemptionTransactionHistoryResponsePagination}
     * @memberof LootboxRedemptionTransactionHistoryResponse
     */
    pagination?: LootboxRedemptionTransactionHistoryResponsePagination;
    /**
     * Applied time filter
     * @type {string}
     * @memberof LootboxRedemptionTransactionHistoryResponse
     */
    timeFilter?: string;
    /**
     * Start date of filter period
     * @type {Date}
     * @memberof LootboxRedemptionTransactionHistoryResponse
     */
    startDate?: Date;
    /**
     * End date of filter period
     * @type {Date}
     * @memberof LootboxRedemptionTransactionHistoryResponse
     */
    endDate?: Date;
}

/**
 * Check if a given object implements the LootboxRedemptionTransactionHistoryResponse interface.
 */
export function instanceOfLootboxRedemptionTransactionHistoryResponse(value: object): value is LootboxRedemptionTransactionHistoryResponse {
    return true;
}

export function LootboxRedemptionTransactionHistoryResponseFromJSON(json: any): LootboxRedemptionTransactionHistoryResponse {
    return LootboxRedemptionTransactionHistoryResponseFromJSONTyped(json, false);
}

export function LootboxRedemptionTransactionHistoryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LootboxRedemptionTransactionHistoryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'transactions': json['transactions'] == null ? undefined : ((json['transactions'] as Array<any>).map(LootboxRedemptionTransactionHistoryItemFromJSON)),
        'pagination': json['pagination'] == null ? undefined : LootboxRedemptionTransactionHistoryResponsePaginationFromJSON(json['pagination']),
        'timeFilter': json['timeFilter'] == null ? undefined : json['timeFilter'],
        'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
    };
}

export function LootboxRedemptionTransactionHistoryResponseToJSON(json: any): LootboxRedemptionTransactionHistoryResponse {
    return LootboxRedemptionTransactionHistoryResponseToJSONTyped(json, false);
}

export function LootboxRedemptionTransactionHistoryResponseToJSONTyped(value?: LootboxRedemptionTransactionHistoryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'transactions': value['transactions'] == null ? undefined : ((value['transactions'] as Array<any>).map(LootboxRedemptionTransactionHistoryItemToJSON)),
        'pagination': LootboxRedemptionTransactionHistoryResponsePaginationToJSON(value['pagination']),
        'timeFilter': value['timeFilter'],
        'startDate': value['startDate'] == null ? undefined : ((value['startDate']).toISOString()),
        'endDate': value['endDate'] == null ? undefined : ((value['endDate']).toISOString()),
    };
}

